import React from 'react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const PrivacidadePage = () => (
  <div>
    <PageHero
      eyebrow="Privacidade"
      title="Compromisso com LGPD e transparência."
      subtitle="Saiba como coletamos, usamos e protegemos seus dados."
      primaryCta={{ label: 'Falar com DPO', href: '/contato' }}
    />
    <section className="bg-white text-slate-900">
      <div className="container mx-auto px-8 lg:px-12 py-16">
        <SectionTitle
          eyebrow="Política"
          title="Diretrizes principais"
          description="Resumo das práticas de privacidade da Zartoo."
          mode="light"
        />
        <div className="grid md:grid-cols-2 gap-6">
          {['Coleta de dados', 'Uso de dados', 'Proteção e segurança', 'Cookies e consentimento'].map((item) => (
            <Card key={item} variant="light">
              <h3 className="text-xl font-semibold">{item}</h3>
              <p className="text-slate-600 mt-2">
                Descrevemos como utilizamos suas informações para entregar a melhor experiência.
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default PrivacidadePage;
